import React from 'react';
import { translator } from '../helpers/translator';

export function HeaderDetail({ setSearch, search, lang }) {
 return (
 <input value={search} onChange={setSearch} type="text" className="form-control" placeholder={translator('search_for_document', lang)} aria-label=""/>
 )
}